var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTppIconRev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#C1F9B9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.9,9.9H14.6c-1,0-1.7,0.8-1.7,1.7v23.7c0,0.4,0.6,0.6,0.8,0.3l9.5-12c0.2-0.2,0.4-0.3,0.7-0.3h3.5 c0.3,0,0.5-0.1,0.7-0.3l8.4-10.5C37.4,11.3,37.4,9.9,35.9,9.9z M26.8,20.2c-0.2,0.2-0.4,0.3-0.7,0.3h-2.6h-0.9 c-0.3,0-0.5,0.1-0.7,0.3l-0.6,0.7l-5.2,6.6c-0.2,0.2-0.5,0.1-0.5-0.2V13.5c0-0.5,0.4-0.9,0.9-0.9h15.8c0.2,0,0.3,0.3,0.2,0.4 L26.8,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13,39.8l7.3-9.1c0.2-0.2,0.4-0.3,0.7-0.3h12.3c0.5,0,0.9-0.4,0.9-0.9V18.8c0-0.2,0.1-0.4,0.2-0.6l2-2.5 c0.3-0.4,0.6-0.3,0.6,0.2v15.4c0,1-0.8,1.7-1.7,1.7h-13c-0.3,0-0.5,0.1-0.7,0.3l-5.2,6.5c-0.1,0.1-0.2,0.2-0.3,0.2h-3 C12.9,40.1,12.9,40,13,39.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTppIconRev);
export default __webpack_public_path__ + "static/media/TPP_Icon_Rev.89538b220ca56191645c78fc3b5760da.svg";
export { ForwardRef as ReactComponent };